import wordCount from 'wordcount'
// import emojiRegex from 'emoji-regex/text.js'
import emojiRegex from 'emoji-regex'
import readingTime from 'reading-time'

const getWordCount = value => wordCount(value)
const getCharacterCount = value => value.length
const getEmojiCount = value => ((value || '').match(emojiRegex()) || []).length
const getReadingTime = value => readingTime(value)

export { getWordCount, getCharacterCount, getEmojiCount, getReadingTime }
